// extracted by mini-css-extract-plugin
module.exports = {"scroll-container":"NotificationPopper_scroll-container__9uhIp","scroll-container-dark":"NotificationPopper_scroll-container-dark__w5P1G"};